import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "../../../../../reducers/initialState";

export default function reducer(state = initialState.currentOffer.financialServicesData, action) {
  const financialServicesInitialState = initialState.currentOffer.financialServicesData;
  switch (action.type) {
    case actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_SUCCEEDED: {
      return {
        ...state,
        document: action.payload.document,
        serviceUpdates: financialServicesInitialState.serviceUpdates,
        servicesLoading: financialServicesInitialState.servicesLoading,
        documentLoaded: true
      };
    }

    case actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_FAILED: {
      return {
        ...state,
        documentLoaded: false,
        editable: true
      };
    }

    case actionTypes.LOAD_WHEELS_SIZES_SUCCEEDED: {
      return {
        ...state,
        wheelSizes: action.payload.wheelSizes,
        wheelSizesLoaded: true
      };
    }

    case actionTypes.LOAD_WHEELS_SIZES_FAILED: {
      return {
        ...state,
        wheelSizesLoaded: false
      };
    }

    case actionTypes.LOAD_OFFER_FINANCIAL_SERVICE_TYPES_SUCCEEDED: {
      return {
        ...state,
        serviceTypesList: action.payload,
        serviceTypesListLoaded: true
      };
    }
    case actionTypes.LOAD_OFFER_FINANCIAL_SERVICE_TYPES_FAILED: {
      return {
        ...state,
        serviceTypesListLoaded: false
      };
    }
    case actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_LINKING_SUCCEEDED: {
      return {
        ...state,
        serviceLinkingList: action.payload,
        serviceLinkingLoaded: true
      };
    }

    case actionTypes.LOAD_OFFER_FINANCIAL_SERVICES_LINKING_FAILED: {
      return {
        ...state,
        serviceLinkingLoaded: false
      };
    }

    case actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_STARTED: {
      return {
        ...state,
        saving: true,
        editable: false
      };
    }

    case actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_SUCCEEDED: {
      return {
        ...state,
        document: action.payload.document,
        documentLoaded: true,
        serviceUpdates: [],
        saving: false
      };
    }

    case actionTypes.SAVE_OFFER_FINANCIAL_SERVICES_UPDATE_FAILED: {
      return {
        ...state,
        saving: false,
        editable: true
      };
    }

    case actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_STARTED: {
      const loading = action.payload.serviceDetails.map(serviceDetail => {
        return { serviceTypeId: serviceDetail.serviceTypeId, value: true };
      });
      return {
        ...state,
        servicesLoading: loading,
        saving: true
      };
    }

    case actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_SUCCEEDED: {
      const updates = action.payload.services.map(service => {
        return { ...service, canComputeService: false };
      });
      const loading = action.payload.serviceDetails.map(serviceDetail => {
        return { serviceTypeId: serviceDetail.serviceTypeId, value: false };
      });

      return {
        ...state,
        serviceUpdates: updates,
        servicesLoading: loading,
        saving: false
      };
    }

    case actionTypes.COMPUTE_OFFER_FINANCIAL_SERVICES_FAILED: {
      const loading = action.payload.serviceDetails.map(serviceDetail => {
        return { serviceTypeId: serviceDetail.serviceTypeId, value: false };
      });
      return {
        ...state,
        servicesLoading: loading,
        saving: false
      };
    }

    case actionTypes.CANCEL_OFFER_FINANCIAL_SERVICES_CHANGES: {
      return {
        ...state,
        serviceUpdates: [],
        editable: false,
        saving: false,
        documentLoaded: false
      };
    }

    case actionTypes.SAVE_ADDED_SERVICES_STARTED: {
      return {
        ...state,
        saving: true
      };
    }

    case actionTypes.DELETE_SERVICE_STARTED: {
      return {
        ...state,
        saving: true
      };
    }
    case eventTypes.OFFER_FINANCIAL_SERVICES_UPDATED: {
      return {
        ...state,
        serviceTypesListLoaded: false
      };
    }

    case actionTypes.CHANGE_EDITABLE_PROPERTY: {
      return {
        ...state,
        editable: action.payload.value
      };
    }

    case eventTypes.OFFER_FINANCIAL_SERVICES_INVALIDATED:
      return financialServicesInitialState;

    default:
      return state;
  }
}
